import Vue from 'vue'
import App from './App.vue'
import router from './router';
import "./styles/index.scss";
import store from './store';
import vuetify from './plugins/vuetify';
import vueFilters from './utils/vueFilters';
import './plugins/svgicon';
import gsap from 'gsap';
import {ScrollTrigger} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
//import './plugins/yandex-map';  // do not register globally - this will slow down first load
//import 'animate.css';

Vue.config.productionTip = false;
Vue.use(vueFilters);

new Vue({
  store,
  router,
  vuetify,
  gsap,
  render: h => h(App)
}).$mount('#app');
